// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widget-course-list-item .ant-typography-secondary {
  margin-bottom: 0;
}
.widget-course-list-item .ant-list-item-meta-description p {
  margin: 0;
}
.widget-course-list-item .file-icon .anticon {
  color: #828282;
}
.widget-course-list-item .ant-list-item-action .anticon {
  vertical-align: -5px;
  font-size: 20px;
}
.widget-course-list-item .ant-list-item-action .ant-list-item-action-split {
  display: none;
}
.widget-course-list-item .ant-list-item-action button {
  min-width: 114px;
}
@media screen and (max-width: 800px) {
  .widget-course-list-item {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
  .widget-course-list-item .file-icon .anticon {
    margin-right: 8px;
  }
  .widget-course-list-item .ant-list-item-action {
    margin-left: 8px !important;
    margin-right: 0px !important;
  }
  .widget-course-list-item .ant-list-item-action button {
    min-width: 50px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/WidgetCourseListItem/styles.less"],"names":[],"mappings":"AAAA;EAGQ,gBAAA;AADR;AAFA;EAQY,SAAA;AAHZ;AALA;EAcY,cAAA;AANZ;AARA;EAoBY,oBAAA;EACA,eAAA;AATZ;AAZA;EAyBY,aAAA;AAVZ;AAfA;EA6BY,gBAAA;AAXZ;AAeI;EAAA;IACI,4BAAA;IACA,6BAAA;EAZN;EAUE;IAMY,iBAAA;EAbd;EAOE;IAWQ,2BAAA;IACA,4BAAA;EAfV;EAGE;IAeY,eAAA;EAfd;AACF","sourcesContent":[".widget-course-list-item {\n     \n    .ant-typography-secondary {\n        margin-bottom: 0;\n    }\n\n    .ant-list-item-meta-description {\n        p {\n            margin: 0;\n        }\n    }\n\n    .file-icon {\n        .anticon {\n            color: #828282;\n        }\n    }\n    \n    .ant-list-item-action {\n        .anticon {\n            vertical-align: -5px;\n            font-size: 20px;\n        }\n\n        .ant-list-item-action-split {\n            display: none;\n        }\n\n        button {\n            min-width: 114px;\n        }\n    }\n\n    @media screen and ( max-width: 800px ) {\n        padding-left: 8px !important;\n        padding-right: 8px !important;\n        \n        .file-icon {\n            .anticon {\n                margin-right: 8px;\n            }\n        }\n\n        .ant-list-item-action {\n            margin-left: 8px !important;\n            margin-right: 0px !important;\n            \n            button {\n                min-width: 50px;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
